import { isEmpty, pickBy } from "lodash-es";

export const sleep = (time?: number) => new Promise((resolve) => setTimeout(resolve, time));

export function toFullWidthNumChar(num: number | string) {
  return num.toString().replace(/\d/g, function (digit) {
    return String.fromCharCode(digit.charCodeAt(0) + 0xfee0);
  });
}

export function notNullObject<T extends object>(data: T) {
  return pickBy(data, (val) => !isEmpty(val)) as T;
}

/**
 * 提交住所 API 前规范化：表单 Cascader 使用 `prefecture: [都道府県, 市区町村]`，
 * 接口需要 `prefecture_name` / `city_name` 且不应收到 `prefecture`。
 */
export function sanitizeAddressForApi(address: Record<string, unknown> | undefined | null): Record<string, unknown> {
  if (!address || typeof address !== "object") return {};
  const { prefecture, ...rest } = address;
  const pair = Array.isArray(prefecture) && prefecture.length >= 2 ? (prefecture as unknown[]) : null;
  const prefecture_name =
    (rest.prefecture_name as string | undefined) ?? (pair?.[0] != null ? String(pair[0]) : undefined);
  const city_name = (rest.city_name as string | undefined) ?? (pair?.[1] != null ? String(pair[1]) : undefined);
  const normalized: Record<string, unknown> = { ...rest, prefecture_name, city_name };
  return notNullObject(normalized);
}

export const getLoginRedirectUrl = (loginPath = "/desk/login", skipRedirect = false): string => {
  if (skipRedirect) {
    return loginPath;
  }
  const currentPath = window.location.pathname + window.location.search;
  if (currentPath === loginPath || currentPath.startsWith(loginPath + "?")) {
    return loginPath;
  }
  const encodedPath = encodeURIComponent(currentPath);
  return `${loginPath}?redirect=${encodedPath}`;
};

export const navigateTo = (path: string): void => {
  const url = new URL(path, window.location.origin);
  window.history.pushState({}, "", url.pathname + url.search);
  window.dispatchEvent(new PopStateEvent("popstate"));
};
